<template>
    <div class="field">
        <span class="field__title" :class="{field__title_big: props.big}">{{title}} <b v-if="required">*</b></span>
        <div class="field__content">
            <slot name="content"></slot>
        </div>
    </div>
</template>
<script setup lang="ts">
const props = defineProps({
    title: {
        type: String,
    },
    required: {
        type: Boolean,
    },
    big: {
        type: Boolean,
    },
})
</script>